import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewClaimComponent } from './new-claim.component';

const routes: Routes = [{ path: '', component: NewClaimComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewClaimRoutingModule { }
